export interface LockFeeConfig {
  id: string | number;
  brandId?: string | number;
  productQuality?: string;
  purchaseChannel?: string;
  amount?: number;
  status?: number;
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
}

export const LockFeeConfigLabels = {
  brandId: '品牌',
  productQuality: '设备成色',
  purchaseChannel: '采购渠道',
  amount: '上锁费用',
  status: '状态',
  remark: '备注',
};
